import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { WashEventType } from '@/apps/washing/types/IWashing';
import { WashHistoryDateRange } from '@/apps/washing/utils/washHistoryDateRange';
import { currentUserPermissionsChanged } from '@/redux/actions';

// History-only filters. The contract/depot scope is shared with the cleaning
// list and stays in `washingSlice`. Nothing here is persisted.
export interface WashingHistoryState {
  // undefined = both event types.
  eventType: WashEventType | undefined;
  vehicleQuery: string;
  // undefined = the default range (the last 7 days ending today in
  // Europe/Oslo). Stored as undefined rather than as dates so it is worked
  // out fresh for every request: after midnight it moves on to the new day,
  // and a reset never brings back a stale one.
  dateRange: WashHistoryDateRange | undefined;
}

const initialState: WashingHistoryState = {
  eventType: undefined,
  vehicleQuery: '',
  dateRange: undefined,
};

const washingHistorySlice = createSlice({
  name: 'washingHistory',
  initialState,
  reducers: {
    setHistoryFilters(
      state,
      action: PayloadAction<Partial<WashingHistoryState>>
    ) {
      Object.assign(state, action.payload);
    },
    resetHistoryFilters: () => initialState,
  },
  // Same as the cleaning list's filters: a change to the signed-in user's own
  // grant starts the filters over.
  extraReducers: (builder) => {
    builder.addCase(currentUserPermissionsChanged, () => initialState);
  },
});

export const { setHistoryFilters, resetHistoryFilters } =
  washingHistorySlice.actions;
export default washingHistorySlice.reducer;
